// extracted by mini-css-extract-plugin
module.exports = {"ScoreInceaserPanel":"ScoreInceaserPanel_ScoreInceaserPanel__2lJS8","ScoreInceaserPanel--hide":"ScoreInceaserPanel_ScoreInceaserPanel--hide__13GlH"};